module.exports = __webpack_public_path__ + "img/dataRoma.cdee5641.png";